<script lang="ts" setup>
const props = defineProps<{
  /** 用户ID */
  id: number
}>()

const handleClick = () => {
  window.open(`/message/whisper?uid=${props.id}`)
}
</script>

<template>
  <button class="m-follow-button" @click="handleClick">私信</button>
</template>

<style lang="scss" scoped>
.m-follow-button {
  cursor: pointer;
  margin: 0;
  padding: 0;
  border: 1px solid var(--color-primary);
  outline: none;
  width: 86px;
  height: 34px;
  border-radius: 4px;
  background-color: #fff;
  color: var(--color-primary);
}
</style>
